import { Box } from '@mui/material'
import MarkDownEditingMode, { MarkDownEditingModeProps } from './MarkDownEditingMode'
import MarkDownPreviewMode from './MarkDownPreviewMode'
import { MarkdownBaseTypographyVariant } from './MarkDownComponents'

export type MarkDownEditorProps = Omit<MarkDownEditingModeProps, 'onChange'> & {
  onChange?: (value: string) => void
  preview?: boolean

  baseTypographyVariant: MarkdownBaseTypographyVariant
}

function MarkDownEditor({
  defaultValue,
  preview,
  onChange,
  baseTypographyVariant,
  label,
  ...otherProps
}: MarkDownEditorProps) {
  if (preview || !onChange) {
    return (
      <Box pb={2}>
        {label}
        <MarkDownPreviewMode {...otherProps} content={defaultValue} baseTypographyVariant={baseTypographyVariant} />
      </Box>
    )
  }
  return (
    <MarkDownEditingMode
      defaultValue={defaultValue}
      onChange={onChange}
      baseTypographyVariant={baseTypographyVariant}
      label={label}
      {...otherProps}
    />
  )
}

export default MarkDownEditor
